module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-266.7b7758c5.svg";